@if (authService.isAuthLoading()) {
    <si-loading-spinner
        [isBlockingSpinner]="true"
        [isSpinnerOverlay]="true"
        [ariaLabel]="'management.loading' | translate"
    />
}

@if (isRouterPathUnauthorized() || isRouterPathNotFound()) {
    <div class="h-screen">
        <router-outlet />
        <tran-notification-outlet />
    </div>
} @else {
    <div class="flex min-h-screen flex-col">
        <tran-ui-header [primaryNavItems]="primaryNavItems" [secondaryNavItems]="secondaryNavItems" />

        <main id="main-content" class="flex-1 pt-[var(--app-header-height)]">
            <router-outlet />
            <tran-notification-outlet />
            <tran-chatbot-bubble />
        </main>

        <tran-ui-footer />
    </div>
}
